module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAGZmZv///yH5BAAHAP8ALAAAAAAMAAwAAAIWhI+pGt37lonSURTvDJtxoIGWRJZAAQA7"